import FAQAccordion from './FAQAccordion'

export default FAQAccordion
